export default __webpack_public_path__ + "static/media/B4.0dff5cb9.png";